import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PodcastState {
  podcast_url: string; // State for the podcast URL
}

const initialState: PodcastState = {
  podcast_url: '', // Default empty URL
};

const podcastPlayback = createSlice({
  name: 'podcastPlayback',
  initialState,
  reducers: {
    setPodcastUrl: (state, action: PayloadAction<string>) => {
      state.podcast_url = action.payload;
    },
  },
});

export const { setPodcastUrl } = podcastPlayback.actions;
export default podcastPlayback.reducer;
